module.exports = __webpack_public_path__ + "static/img/登录.20db186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/登录.png
// module id = SFRF
// module chunks = 95